const ensureSelectedFilterOptions = ({ options, selectedValues, getSelectedOption }) => {
  const baseOptions = Array.isArray(options) ? options.filter(Boolean) : [];
  const optionValues = new Set(baseOptions.map((option) => option.value));
  const normalizedSelectedValues = Array.isArray(selectedValues) ? selectedValues : [selectedValues];

  const missingSelectedOptions = [...new Set(normalizedSelectedValues)]
    .filter((value) => value !== undefined && value !== null)
    .filter((value) => !optionValues.has(value))
    .map((value) => ({
      value,
      label: value,
      totalCount: 0,
      totalCountTitle: 'No matching workflow runs for the current filters',
      ...getSelectedOption?.(value)
    }));

  return [...missingSelectedOptions, ...baseOptions];
};

export default ensureSelectedFilterOptions;
